// extracted by mini-css-extract-plugin
export var faqListWrap = "faqList-module--faqListWrap--IkuRh";
export var listHeader = "faqList-module--listHeader--6fipX";
export var faqList = "faqList-module--faqList--WNWDt";
export var faqBack = "faqList-module--faqBack--XV-py";
export var faqSection = "faqList-module--faqSection--G-5+F";
export var slideUp = "faqList-module--slideUp---UA9M";
export var slideUpLarge = "faqList-module--slideUpLarge--+WYxF";